import { useEffect, useState } from 'react';
import Footer from '../../components/Footer/Footer';
import Menu from '../../components/Menu/Menu';
import Toast from '../../components/Toast/Toast';
import {
    activateUpgradeRequest,
    approveUpgradeRequest,
    getUpgradeRequests,
    rejectUpgradeRequest,
} from '../../services/UpgradeRequestsService';
import { copyToClipboard } from '../../utils/copyToClipboard';
import UpgradeRequestRow from './UpgradeRequestRow';

function UpgradeRequests() {
    const [requests, setRequests] = useState([]);

    const [status, setStatus] = useState('');

    const [notification, setNotification] = useState({ type: '', text: '' });

    function onError(err) {
        console.error(err.response ? err.response.data : err.message);
        setNotification({
            type: 'error',
            text: err.response ? err.response.data : err.message,
        });
    }

    function loadRequests() {
        getUpgradeRequests(status)
            .then(result => setRequests(result))
            .catch(onError);
    }

    useEffect(() => {
        loadRequests();
    }, [status]);

    function onApproveClick(event) {
        const id = event.target.id.replace('approve', '');
        approveUpgradeRequest(id)
            .then(result => {
                setNotification({
                    type: result.emailSent ? 'success' : 'info',
                    text: result.emailSent
                        ? 'Payment link sent by email.'
                        : 'Email not sent. Copy the link and send it manually.',
                });
                loadRequests();
            })
            .catch(onError);
    }

    function onRejectClick(event) {
        const id = event.target.id.replace('reject', '');
        rejectUpgradeRequest(id)
            .then(result => loadRequests())
            .catch(onError);
    }

    function onActivateClick(event) {
        const id = event.target.id.replace('activate', '');
        activateUpgradeRequest(id)
            .then(result => {
                setNotification({ type: 'success', text: 'Plan activated.' });
                loadRequests();
            })
            .catch(onError);
    }

    function onCopyClick(event) {
        const id = event.target.id.replace('copy', '');
        const request = requests.find(r => r.id == id);
        copyToClipboard(request.paymentLink)
            .then(() =>
                setNotification({ type: 'success', text: 'Link copied.' }),
            )
            .catch(onError);
    }

    return (
        <>
            <Menu />
            <main className="content">
                <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center py-4">
                    <div className="d-block mb-4 mb-md-0">
                        <h2 className="h4">Upgrade Requests</h2>
                    </div>
                    <div className="btn-toolbar mb-2 mb-md-0">
                        <select
                            id="status"
                            className="form-select"
                            value={status}
                            onChange={event => setStatus(event.target.value)}
                        >
                            <option value="">All</option>
                            <option value="pending">Pending</option>
                            <option value="link_sent">Link sent</option>
                            <option value="activated">Activated</option>
                            <option value="rejected">Rejected</option>
                        </select>
                    </div>
                </div>
                <div className="card card-body border-0 shadow table-wrapper table-responsive">
                    <table className="table table-hover">
                        <thead>
                            <tr>
                                <th className="border-gray-200">User</th>
                                <th className="border-gray-200">Plan</th>
                                <th className="border-gray-200">Note</th>
                                <th className="border-gray-200">Status</th>
                                <th className="border-gray-200">Requested</th>
                                <th className="border-gray-200">Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            {requests && requests.length ? (
                                requests.map(request => (
                                    <UpgradeRequestRow
                                        key={request.id}
                                        data={request}
                                        onApproveClick={onApproveClick}
                                        onRejectClick={onRejectClick}
                                        onCopyClick={onCopyClick}
                                        onActivateClick={onActivateClick}
                                    />
                                ))
                            ) : (
                                <></>
                            )}
                        </tbody>
                    </table>
                </div>
                <Footer />
            </main>
            <Toast
                type={notification.type}
                text={notification.text}
                onShow={() => setNotification({})}
            />
        </>
    );
}

export default UpgradeRequests;
